export default __webpack_public_path__ + "static/media/PublishInventory.dcfcaf84.svg";